import { render, staticRenderFns } from "./ServiceHandle.vue?vue&type=template&id=18e9611a&scoped=true&"
import script from "./ServiceHandle.vue?vue&type=script&lang=js&"
export * from "./ServiceHandle.vue?vue&type=script&lang=js&"
import style0 from "./ServiceHandle.vue?vue&type=style&index=0&id=18e9611a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9611a",
  null
  
)

export default component.exports